import axios from "../../../../../axios";
import React from "react";
import "./preReadDeleteConfir.css";
import { toast } from "react-toastify";

const PreReadDeleteConfirmation = ({
  setPreSDelete,
  scheduleData,
  scheduleData_id,
  setIsDeleted,
}) => {
  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);
  let teacher_id = Teacher_Json;
  const publishedDelete = async () => {
    try {
      let res = await axios.delete(
        `/api/v1/homework/preRead/delete/${scheduleData_id}`,
        {
          data: { teacher_id },
        }
      );

      if (res) {
        setIsDeleted(true);
        toast.success("Deleted Successfully");
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div className=" delete_activity_transprant_body ">
        <img
          src="/images/cross-circle3.svg"
          className=" delete_activity_close_btn"
          alt=""
          onClick={(e) => setPreSDelete(false)}
        />
        <div className=" p-3 d-flex align-items-center justify-content-center flex-column delete_activity_container shadow">
          <div className="gap-2 mb-5 d-flex align-items-center justify-content-center">
            <img
              className="activity_img"
              src="/images/ActivityProps.png"
              alt=""
            />

            <span>{scheduleData?.name}</span>
          </div>
          <div className=" col-12 d-flex align-items-center justify-content-center flex-column text-center">
            <span className="mb-3">
              Are you sure you want to delete this preread?
            </span>
            <div className="col-12 p-0 gap-3 flex-wrap d-flex justify-content-center ">
              <button
                className="btn btn-danger col-sm-5  delete_btn"
                onClick={publishedDelete}
              >
                Yes
              </button>
              <button
                className="btn btn-danger col-sm-5 delete_btn"
                autoFocus
                onClick={(e) => setPreSDelete(false)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PreReadDeleteConfirmation;
